<template>
  <div class="w-full max-w-270 text-app-color">
    <div class="w-full p-15 md:p-30 pt-10 pb-40 rounded-20"
         :class="isDarkMode ? 'bg-sidebar' : 'bg-white shadow-team-plan'"
    >
      <div>
        <p class="text-26 font-semibold leading-none mb-10">Teams.</p>
        <p class="text-14">Everything you need for great teamwork, in one tool.</p>
        <div class="flex mt-20">
          <div class="text-35 font-bold leading-none">
            <span>${{ price }}</span>
          </div>
          <div class="ml-15 text-14">
            <p class="font-bold leading-none">per user/month</p>
            <p class="text-grey-275">billed {{ billedAt }}</p>
          </div>
        </div>
      </div>

      <div class="text-center mt-35">
        <button
          class="border-2 rounded-full px-20 py-10 font-medium text-white anim-color
               bg-brand border-brand hover:bg-brand-hover hover:border-brand-hover"
          :disabled="!isTrialPlan && !isExpired"
          @click="upgrade"
        >
          {{ btnTitle }}
        </button>
      </div>

      <div class="mt-30">
        <div>
          <div class="flex items-center mt-20">
            <p class="font-semibold">What’s included?</p>
          </div>

          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14">Collaborative workspace</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14">Unlimited spaces & pages</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14">Unlimited guests</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14">500GB storage space</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14">Admin tools</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14">Tasks, planner and chat</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    billAnnually: Boolean
  },

  setup (props) {
    const { state, getters } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const teamPlanMonthly = computed(() => getters.teamPlanMonthly)
    const teamPlanYearly = computed(() => getters.teamPlanYearly)
    const isTrialPlan = computed(() => getters.isTrialPlan)
    const isExpired = computed(() => getters.isExpired)

    const team = computed(() => state.team.team)
    const user = computed(() => state.profile.user)
    const currentPlan = computed(() => getters.currentPlan)
    const billedAt = computed(() => props.billAnnually ? 'annually' : 'monthly')

    const storage = computed(() => props.billAnnually ? '450GB' : '350GB')

    const price = computed(() => {
      if (!isTrialPlan.value) {
        return parseInt(currentPlan.value.pricePerMonth)
      }
      return props.billAnnually ? parseInt(teamPlanYearly.value.pricePerMonth) : parseInt(teamPlanMonthly.value.pricePerMonth)
    })

    const btnTitle = computed(() => {
      if (isExpired.value) return 'Renew'
      return isTrialPlan.value ? 'Upgrade to Teams' : 'Your current plan'
    })

    function upgrade () {
      window.open(`https://helloivy.co/upgrade?userId=${user.value.id}&teamId=${team.value.id}`, '_blank')
    }

    return {
      // computed
      isDarkMode,
      isDraculaTheme,
      price,
      btnTitle,
      isTrialPlan,
      isExpired,
      storage,
      billedAt,
      // function
      upgrade
    }
  }
})
</script>
